import PropTypes from 'prop-types';
import React from 'react';
import {useIntl} from 'react-intl';
import {
  // Helpers
  SPACE,
  // Components
  Button,
  InputField,
  Form,
} from '@lookiero/aurora';

import {FormField} from '@components/molecules/FormFieldsBuilder/FormField';
import {TEXT} from './ResetPassword.definition';

export const ResetPasswordForm = ({
  handleBlur,
  handleChange,
  getFieldMeta,
  handleSubmit,
  values,
  isValid,
  dirty,
  isSubmitting,
}) => {
  const {formatMessage} = useIntl();

  return (
    <Form marginBottom={SPACE.SPACE_8}>
      <FormField
        component={InputField}
        getFieldMeta={getFieldMeta}
        handleBlur={handleBlur}
        handleChange={handleChange}
        label={{key: TEXT.INPUT_PASSWORD.id}}
        marginBottom={SPACE.SPACE_4}
        type="password"
        uniqueKey="password"
        values={values}
      />
      <FormField
        component={InputField}
        getFieldMeta={getFieldMeta}
        handleBlur={handleBlur}
        handleChange={handleChange}
        label={{key: TEXT.INPUT_REPEAT_PASSWORD.id}}
        marginBottom={SPACE.SPACE_6}
        type="password"
        uniqueKey="repeatPassword"
      />
      <Button busy={isSubmitting} disabled={!dirty || !isValid} onPress={handleSubmit}>
        {formatMessage(TEXT.CTA)}
      </Button>
    </Form>
  );
};
ResetPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  getFieldMeta: PropTypes.func.isRequired,
  isValid: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  dirty: PropTypes.bool,
  values: PropTypes.shape({
    password: PropTypes.string.isRequired,
    repeatPassword: PropTypes.string.isRequired,
  }).isRequired,
};
